import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faAngellist } from '@fortawesome/free-brands-svg-icons/faAngellist';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faTelegram } from '@fortawesome/free-brands-svg-icons';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/nsmrnf',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://facebook.com/nsmrnf',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.instagram.com/nsmrnf/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.linkedin.com/in/nicksmirnovs/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://angel.co/u/nsmrnf',
    label: 'Angel List',
    icon: faAngellist,
  },
  {
    link: 'https://twitter.com/n_smirnofff',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'mailto:me@nsmrnf.com',
    label: 'Email',
    icon: faEnvelope,
  },
  {
    link: 'https://t.me/nsmrnf',
    label: 'Telegram',
    icon: faTelegram,
  },
];

export default data;
